import { Component } from '@angular/core';
import { AlertController } from '../../alert.controller';

@Component({
  selector: 'app-loader-dialog',
  templateUrl: './loader-dialog.component.html',
  styleUrls: ['./loader-dialog.component.scss']
})
export class LoaderDialogComponent {
  constructor(public alertController: AlertController) { /**/ }
}
